import PrivacyComponent from './PrivacyContainer';

export default PrivacyComponent;
